import React from 'react';

import { CustomSVGProps } from '@cineamo/ui/src/icons/CustomSVGProps.types';

export function IconVoucher48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="voucher">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 8.34315 1.34315 7 3 7H45C46.6569 7 48 8.34315 48 10V19H47C44.2386 19 42 21.2386 42 24C42 26.7614 44.2386 29 47 29H48V38C48 39.6569 46.6569 41 45 41H3C1.34315 41 0 39.6569 0 38V29H1C3.76142 29 6 26.7614 6 24C6 21.2386 3.76142 19 1 19H0V10ZM3 9C2.44772 9 2 9.44772 2 10V17.0709C5.39229 17.5561 8 20.4735 8 24C8 27.5265 5.39229 30.4439 2 30.9291V38C2 38.5523 2.44771 39 3 39H45C45.5523 39 46 38.5523 46 38V30.9291C42.6077 30.4439 40 27.5265 40 24C40 20.4735 42.6077 17.5561 46 17.0709V10C46 9.44772 45.5523 9 45 9H3Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.8944 14.8944L19.8944 34.8944L18.1056 34L28.1055 14L29.8944 14.8944Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 22.4469C18.6569 22.4469 20 21.1037 20 19.4469C20 17.79 18.6569 16.4469 17 16.4469C15.3431 16.4469 14 17.79 14 19.4469C14 21.1037 15.3431 22.4469 17 22.4469ZM17 24.4469C19.7614 24.4469 22 22.2083 22 19.4469C22 16.6854 19.7614 14.4469 17 14.4469C14.2386 14.4469 12 16.6854 12 19.4469C12 22.2083 14.2386 24.4469 17 24.4469Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31 32.4469C32.6569 32.4469 34 31.1037 34 29.4469C34 27.79 32.6569 26.4469 31 26.4469C29.3431 26.4469 28 27.79 28 29.4469C28 31.1037 29.3431 32.4469 31 32.4469ZM31 34.4469C33.7614 34.4469 36 32.2083 36 29.4469C36 26.6854 33.7614 24.4469 31 24.4469C28.2386 24.4469 26 26.6854 26 29.4469C26 32.2083 28.2386 34.4469 31 34.4469Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconVoucher24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="voucher">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V9.87788L23.3332 10.1135C22.5551 10.3886 22 11.1308 22 12C22 12.8693 22.5551 13.6114 23.3332 13.8865L24 14.1221V19C24 20.1046 23.1046 21 22 21H2C0.895432 21 0 20.1046 0 19V14H1C2.10457 14 3 13.1046 3 12C3 10.8954 2.10457 10 1 10H0V5ZM22 5H2V8.12602C3.72523 8.57006 5 10.1362 5 12C5 13.8638 3.72523 15.4299 2 15.874V19H22V15.4646C20.8052 14.7734 20 13.4817 20 12C20 10.5183 20.8052 9.22657 22 8.53543V5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.64305 16.9604L8.35681 16.1887L14.3568 6.18872L15.6431 6.96046L9.64305 16.9604ZM9.5 9.07458C9.5 9.62686 9.05228 10.0746 8.5 10.0746C7.94772 10.0746 7.5 9.62686 7.5 9.07458C7.5 8.5223 7.94772 8.07458 8.5 8.07458C9.05228 8.07458 9.5 8.5223 9.5 9.07458ZM11 9.07458C11 10.4553 9.88071 11.5746 8.5 11.5746C7.11929 11.5746 6 10.4553 6 9.07458C6 7.69387 7.11929 6.57458 8.5 6.57458C9.88071 6.57458 11 7.69387 11 9.07458ZM16.5 14.0746C16.5 14.6269 16.0523 15.0746 15.5 15.0746C14.9477 15.0746 14.5 14.6269 14.5 14.0746C14.5 13.5223 14.9477 13.0746 15.5 13.0746C16.0523 13.0746 16.5 13.5223 16.5 14.0746ZM18 14.0746C18 15.4553 16.8807 16.5746 15.5 16.5746C14.1193 16.5746 13 15.4553 13 14.0746C13 12.6939 14.1193 11.5746 15.5 11.5746C16.8807 11.5746 18 12.6939 18 14.0746Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
